export interface RolePermission {
  path: string;
  oldPath?: string;
  permission: {
    Ops?: boolean;
    Admin: boolean;
    Creator: boolean;
    Editor: boolean;
    Moderator: boolean;
    Attendee: boolean;
  };
  scope?: string;
}

const rolesPermissionsMatrixConst = {
  home: {
    path: '/home',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: true,
    },
  },
  profile: {
    path: '/home/setup/profile',
    oldPath: '/home/profile/edit',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  profileMyInfo: {
    path: '/home/setup/profile/info',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  profileMyRewards: {
    path: '/home/setup/profile/rewards',
    oldPath: '/home/profile/rewards',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  account: {
    path: '/home/setup/account',
    permission: {
      Admin: true,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  accountTeam: {
    path: '/home/setup/account/team',
    oldPath: '/home/profile/team',
    permission: {
      Admin: true,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  accountSubscription: {
    path: '/home/setup/account/subscription',
    oldPath: '/home/profile/plan',
    permission: {
      Admin: true,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  accountDomain: {
    path: '/home/setup/account/domain',
    oldPath: '/home/profile/domains',
    permission: {
      Admin: true,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  accountSecurity: {
    path: '/home/setup/account/security',
    permission: {
      Admin: true,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settings: {
    path: '/home/setup/settings',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsDefaults: {
    path: '/home/setup/settings/defaults',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsPresenters: {
    path: '/home/setup/settings/presenters',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsIntegrations: {
    path: '/home/setup/settings/integrations',
    oldPath: '/home/profile/integrations',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsScripts: {
    path: '/home/setup/settings/scripts',
    oldPath: '/home/profile/scripts',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsProperties: {
    path: '/home/setup/settings/properties',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  settingsSavedReplies: {
    path: '/home/setup/settings/saved-replies',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  newEWebinar: {
    path: '/home/new',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  shareWebinar: {
    path: 'share-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  enableRelay: {
    path: 'enable-relay',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  duplicateEwebinar: {
    path: 'duplicate-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  publishEwebinar: {
    path: 'publish-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  unpublishEwebinar: {
    path: 'unpublish-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  deleteEwebinar: {
    path: 'delete-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  discardChangesEwebinar: {
    path: 'discard-changes-webinar',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSchedule: {
    path: '/home/webinar/:setId/edit/schedule',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarScheduleSet: {
    path: '/home/webinar/:setId/edit/schedule/#set',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarScheduleSettings: {
    path: '/home/webinar/:setId/edit/schedule/#settings',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarChatSettings: {
    path: '/home/webinar/:setId/edit/chat',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistration: {
    path: '/home/webinar/:setId/edit/registration',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistrationPage: {
    path: '/home/webinar/:setId/edit/registration/page',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistrationForm: {
    path: '/home/webinar/:setId/edit/registration/form',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistrationThankyou: {
    path: '/home/webinar/:setId/edit/registration/thankyou',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistrationSettings: {
    path: '/home/webinar/:setId/edit/registration/settings',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarRegistrationWidgetSettings: {
    path: '/home/webinar/:setId/edit/registration/widget',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarNotifications: {
    path: '/home/webinar/:setId/edit/notifications',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarInteractions: {
    path: '/home/webinar/:setId/edit/interactions',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarInteractionsDetail: {
    path: '/home/webinar/:setId/edit/interactions/:interactionId',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSettings: {
    path: '/home/webinar/:setId/edit/settings',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSettingsDisplay: {
    path: '/home/webinar/:setId/edit/settings/#display',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSettingsSharing: {
    path: '/home/webinar/:setId/edit/settings/#sharing',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSettingsIntegrations: {
    path: '/home/webinar/:setId/edit/settings/#integrations',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalWebinarSettingsChat: {
    path: '/home/webinar/:setId/edit/settings/#chat',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardAllAnalyticsAddon: {
    path: '/home/universal/dashboard/addon',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardAllAnalytics: {
    path: '/home/universal/dashboard/analytics',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardAllParticipants: {
    path: '/home/universal/dashboard/registrants',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardAllChat: {
    path: '/home/universal/dashboard/chat',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  portalDashboardInteractions: {
    path: '/home/webinar/:setId/dashboard/interactions',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardAnalytics: {
    path: '/home/webinar/:setId/dashboard/analytics',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardRegistrants: {
    path: '/home/webinar/:setId/dashboard/registrants',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalDashboardChat: {
    path: '/home/webinar/:setId/dashboard/chat',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: true,
      Attendee: false,
    },
  },
  portalSeriesWebinars: {
    path: '/home/series/:seriesId/edit/webinars',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesSettings: {
    path: '/home/series/:seriesId/edit/settings',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesRegistration: {
    path: '/home/series/:seriesId/edit/registration',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesRegistrationLandingPage: {
    path: '/home/series/:seriesId/edit/registration/landing-page',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesRegistrationSubmitEmail: {
    path: '/home/series/:seriesId/edit/registration/submit-email',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesRegistrationForm: {
    path: '/home/series/:seriesId/edit/registration/form',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  portalSeriesNotifications: {
    path: '/home/series/:seriesId/edit/notifications',
    permission: {
      Admin: true,
      Creator: true,
      Editor: true,
      Moderator: false,
      Attendee: false,
    },
  },
  opsHome: {
    path: '/ops/teams',
    permission: {
      Ops: true,
      Admin: false,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  opsDashboard: {
    path: '/ops/dashboard',
    permission: {
      Ops: true,
      Admin: false,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  opsMonthly: {
    path: '/ops/monthly',
    permission: {
      Ops: true,
      Admin: false,
      Creator: false,
      Editor: false,
      Moderator: false,
      Attendee: false,
    },
  },
  opsTeams: {
    path: '/ops/teams',
    permission: {
      Ops: true,
      Admin: false,
      Editor: false,
      Creator: false,
      Moderator: false,
      Attendee: false,
    },
  },
} as const;

export type rolesPermissionsMatrix = Record<
  keyof typeof rolesPermissionsMatrixConst,
  RolePermission
>;
export const rolesPermissionsMatrix: rolesPermissionsMatrix = rolesPermissionsMatrixConst;

export const getRoute = (path: string, params: Record<string, string>): string => {
  return path.replace(/:[a-zA-Z?]+/g, (match) => {
    const varName = match.slice(1);
    return params[varName] ?? match;
  });
};

export const getWebinarDashboardRoute = (path: string, isDraft?: boolean): string => {
  if (path.includes('registrants')) {
    path = rolesPermissionsMatrix.portalDashboardRegistrants.path;
  }

  if (path.includes('chat')) {
    path = rolesPermissionsMatrix.portalDashboardChat.path;
  }

  if (path.includes('analytics')) {
    path = rolesPermissionsMatrix.portalDashboardAnalytics.path;
  }

  if (path.includes('dashboard') && isDraft) {
    // For Draft webinars switch to Edit mode
    path = rolesPermissionsMatrix.portalWebinarScheduleSettings.path;
  }

  return path;
};

export const getUniversalDashboardRoute = (path: string): string => {
  // If currently on registrants, go to participants tab
  if (path.includes('registrants')) {
    path = rolesPermissionsMatrix.portalDashboardAllParticipants.path;
  }

  if (path.includes('analytics')) {
    path = rolesPermissionsMatrix.portalDashboardAllAnalytics.path;
  }

  if (path.includes('chat')) {
    path = rolesPermissionsMatrix.portalDashboardAllChat.path;
  }

  /* If the current tab we're on doesn't exist in 'all' go to analytics */
  if (path.includes('/edit/') || path.match(/interactions/)) {
    path = rolesPermissionsMatrix.portalDashboardAllAnalytics.path;
  }

  return path;
};

export const getRouteForSet = (currentPath: string, setId: string): string | undefined => {
  // Replace /\d+/ with /:setId/
  const path = currentPath.replace(/\/(\d+|all)\//, `/:setId/`);

  return path
    ? getRoute(path, {
        setId: setId,
      })
    : undefined;
};
